/**
 * These advertiser disclosure messages stem from the canoncial marketplace
 * product types: https://github.com/NerdWallet/js-nw-api-sdk/blob/master/src/marketplace-sdk/constants.js#L35-L43
 */
var PRODUCT_TYPES = {
  CREDIT_CARDS: 'credit_cards',
  INVESTING: 'investing'
};
export default PRODUCT_TYPES;